import { render, staticRenderFns } from "./CicloStandardDettaglioNew.vue?vue&type=template&id=136077c3&"
import script from "./CicloStandardDettaglioNew.vue?vue&type=script&lang=js&"
export * from "./CicloStandardDettaglioNew.vue?vue&type=script&lang=js&"
import style0 from "./CicloStandardDettaglioNew.vue?vue&type=style&index=0&id=136077c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports